import { render, staticRenderFns } from "./channel-private.vue?vue&type=template&id=b15c47bc&scoped=true"
import script from "./channel-private.vue?vue&type=script&lang=js"
export * from "./channel-private.vue?vue&type=script&lang=js"
import style0 from "./channel-private.vue?vue&type=style&index=0&id=b15c47bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15c47bc",
  null
  
)

export default component.exports